import { c as _c } from "react/compiler-runtime";
import EventsHero from "@/components/events/EventsHero";
import FeaturedEvent from "@/components/events/FeaturedEvent";
import EventCalendar from "@/components/events/EventCalendar";
import PastEvents from "@/components/events/PastEvents";
import ResearchCTA from "@/components/home/ResearchCTA";
import SeoHead from "@/components/seo/SeoHead";
import { breadcrumbJsonLd, seoFromPage } from "@/lib/seo";
export default function EventsPage() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = seoFromPage("events");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const seo = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><SeoHead {...seo} jsonLd={breadcrumbJsonLd([{
        name: "Home",
        path: "/"
      }, {
        name: "Events",
        path: "/events"
      }])} /><main><EventsHero /><FeaturedEvent /><EventCalendar /><PastEvents /><ResearchCTA /></main></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}